import { UIPAGE } from "@/constants/ui-page.constants";
import { RouteInfo } from "../types";
import { authGuard, permissionGuard } from "../guards/index";
import { rootPathGuardFromChildren } from "../guards/rootPathGuard";

const ViewCustomer360 = () => import(/* webpackChunkName: "chunk-customer-360" */ "@/views/customer/customer-360/Customer360.vue");

const CustomerSectionOrders = () =>
	import(/* webpackChunkName: "chunk-customer-360" */ "@/views/customer/customer-360/components/CustomerOrders.vue");
const CustomerSectionWorkTasks = () =>
	import(/* webpackChunkName: "chunk-customer-360" */ "@/views/customer/customer-360/components/CustomerWorkTasks.vue");
const CustomerSectionGrupoAireWorkTasks = () =>
	import(/* webpackChunkName: "chunk-customer-360" */ "@/views/customer/customer-360/grupo-aire-work-tasks/CustomerGrupoAireWorkTasks.vue");
const CustomerSectionFinances = () =>
	import(/* webpackChunkName: "chunk-customer-360" */ "@/views/customer/customer-360/components/CustomerFinances.vue");
const CustomerSectionTasks = () => import(/* webpackChunkName: "chunk-customer-360" */ "@/views/customer/customer-360/components/CustomerTasks.vue");
const CustomerSectionJiraTickets = () =>
	import(/* webpackChunkName: "chunk-customer-360" */ "@/views/customer/customer-360/jira-tickets/CustomerJiraTickets.vue");
const CustomerSectionNotes = () => import(/* webpackChunkName: "chunk-customer-360" */ "@/views/customer/customer-360/components/CustomerNotes.vue");
const CustomerSectionChargesCredits = () =>
	import(/* webpackChunkName: "chunk-customer-360" */ "@/views/customer/customer-360/charges-and-credits/CustomerChargesCredits.vue");
const CustomerSectionFollowUp = () =>
	import(/* webpackChunkName: "chunk-customer-360" */ "@/views/customer/customer-360/follow-up/CustomerFollowUp.vue");
const CustomerSectionBilling = () => import(/* webpackChunkName: "chunk-customer-360" */ "@/views/customer/customer-360/billing/CustomerBilling.vue");
const CustomerSectionDocuments = () =>
	import(/* webpackChunkName: "chunk-customer-360" */ "@/views/customer/customer-360/documents/CustomerDocuments.vue");
const CustomerSectionProducts = () =>
	import(/* webpackChunkName: "chunk-customer-360" */ "@/views/customer/customer-360/products/CustomerProducts.vue");
const CustomerSectionAggrupations = () =>
	import(/* webpackChunkName: "chunk-customer-360" */ "@/views/customer/customer-360/aggrupations/CustomerAggrupations.vue");
const CustomerSectionHandover = () =>
	import(/* webpackChunkName: "chunk-customer-360" */ "@/views/customer/customer-360/components/handover/CustomerHandover.vue");

export const Customer360RouteChildren: RouteInfo[] = [
	{
		id: UIPAGE.CUSTOMER_360_FOLLOW_UP,
		path: "follow-up",
		component: CustomerSectionFollowUp,
		title: "customers.customer_360.follow_up.display"
	},
	{
		id: UIPAGE.CUSTOMER_360_BILLING,
		path: "billing",
		component: CustomerSectionBilling,
		title: "customers.customer_360.billing.display"
	},
	{
		id: UIPAGE.CUSTOMER_360_DOCUMENTS,
		path: "documents",
		component: CustomerSectionDocuments,
		title: "customers.customer_360.documents.display"
	},
	{
		id: UIPAGE.CUSTOMER_360_PRODUCTS,
		path: "products",
		component: CustomerSectionProducts,
		title: "customers.customer_360.products.display"
	},
	{
		id: UIPAGE.CUSTOMER_360_CHARGES_CREDITS,
		path: "charges-credits",
		component: CustomerSectionChargesCredits,
		title: "customers.customer_360.charges_credits.display"
	},
	{
		id: UIPAGE.CUSTOMER_360_ORDERS,
		path: "orders",
		component: CustomerSectionOrders,
		title: "customers.customer_360.orders.display"
	},
	{
		id: UIPAGE.CUSTOMER_360_WORK_TASKS,
		path: "work-tasks",
		component: CustomerSectionWorkTasks,
		title: "customers.customer_360.workTasks.display"
	},
	{
		id: UIPAGE.CUSTOMER_360_GRUPO_AIRE_WORK_TASKS,
		path: "aire-work-tasks",
		component: CustomerSectionGrupoAireWorkTasks,
		title: "customers.customer_360.grupoAireWorkTasks.display"
	},
	{
		id: UIPAGE.CUSTOMER_360_FINANCES,
		path: "finances",
		component: CustomerSectionFinances,
		title: "customers.customer_360.finances.display"
	},
	{
		id: UIPAGE.CUSTOMER_360_TASKS,
		path: "tasks",
		component: CustomerSectionTasks,
		title: "customers.customer_360.tasks.display"
	},
	{
		id: UIPAGE.CUSTOMER_360_JIRA_TICKETS,
		path: "jira-tickets",
		component: CustomerSectionJiraTickets,
		title: "customers.customer_360.jiraTickets.display"
	},
	{
		id: UIPAGE.CUSTOMER_360_NOTES,
		path: "notes",
		component: CustomerSectionNotes,
		title: "customers.customer_360.notes.display"
	},
	{
		id: UIPAGE.CUSTOMER_360_AGGRUPATIONS,
		path: "aggrupations",
		component: CustomerSectionAggrupations,
		title: "customers.customer_360.aggrupations.display"
	},
	{
		id: UIPAGE.CUSTOMER_360_HANDOVER,
		path: "handover",
		component: CustomerSectionHandover,
		title: "customers.customer_360.handover.display"
	}
];

export const Customer360Route: RouteInfo = {
	id: UIPAGE.CUSTOMER_360,
	path: "/customers/:id",
	component: ViewCustomer360,
	guards: [authGuard, permissionGuard, rootPathGuardFromChildren],
	props: (route) => ({
		id: route.query.id
	}),
	children: Customer360RouteChildren
};
